module.exports = __webpack_public_path__ + "img/herb-lemongrass-350x184.0aa8e67e.jpg";